import { DeleteOutline } from '@mui/icons-material';
import { styled } from '@mui/material';
import { Grid } from '@mui/system';

export const GridContainer = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  padding: theme.spacing(2),
  borderRadius: 5,
}));

export const StyledDeleteIcon = styled(DeleteOutline)(({ theme }) => ({
  fontSize: '5rem',
  color: '#fff',
}));